import { render, staticRenderFns } from "./VaIconVue.vue?vue&type=template&id=d3dea912&"
import script from "./VaIconVue.vue?vue&type=script&lang=js&"
export * from "./VaIconVue.vue?vue&type=script&lang=js&"
import style0 from "./VaIconVue.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports